import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vq-radio',
  templateUrl: './form-radio.component.html',
  styleUrls: []
})
export class FormRadioComponent implements OnInit {

  @Input('vqModel') model:any;
  @Input('vqLabel') label:string;
  @Input('vqLabelGetter') labelGetter:any = this._defaultLabelGetter;
  @Input('vqValueGetter') valueGetter:any = this._defaultValueGetter;
  @Input('vqOptions') values:Array<string> = [];
  @Input('vqErrors') errors:Array<string> = [];
  @Input('vqHelpText') helpText:string;

  @Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();

  id:string;

  constructor() { }

  ngOnInit() {
  }

  private _defaultLabelGetter(o:any):any {
    return o;
  }

  private _defaultValueGetter(o:any):any {
    return o;
  }

  public getLabel(o) {
    return this.labelGetter(o);
  }

  public getValue(o) {
    return this.valueGetter(o);
  }

  public change($event) {
  	this.model = $event;
  	this.modelChange.emit($event);
  }

  public hasError() {
    return (this.errors && this.errors.length > 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-radio/form-radio.component.ts